<template>
	<div class="lovelist">
		<header-view :tabsign='3'></header-view>
		<div class="con_tent">
			
			<div class="concar w12 min-h">
				<div class="right_c">
					<div class="label">捐助查询：</div>
					<div class="screenbox">
						<div class="searchcon">
							<el-input prefix-icon='el-icon-search' class="inputa" size='medium' v-model="name" placeholder="实时榜单捐助人"></el-input>
						</div>
					</div>
					<div class="datacon">
						<el-date-picker 
						v-model="donateStartDate"
						type="date"
						size='medium'
						@change='changeStart'
						placeholder="实时捐助开始时间">
						</el-date-picker>
					</div>
					<div class="line_c"></div>
					<div class="datacon">
						<el-date-picker
						v-model="donateStopDate"
						type="date"
						size='medium'
						@change='changeEnd'
						placeholder="实时捐助结束时间">
						</el-date-picker>
					</div>
					<div class="btn_search" @click="searchbtn">查询</div>
				</div>
				
				<div class="ranktable">
				  <table>
					<th style="text-align: center;">排序</th>
					<th style="text-align: center;">捐款人</th>
					<th style="text-align: center;">捐款金额</th>
					<th style="text-align: center;">捐助时间</th>
					<th style="text-align: center;">关联项目</th>
						  
					
					<tr v-if="searchv&&(list.length > 0)" v-for="(item, index) in list" :key="index" @click="goDetail(item)">
						<td>{{ index + 1 }}</td>
						<td>
							<label>{{ item.donationUserId||'' }}</label>
						</td>
						<td>{{ getFormatMoney(item.money) }}</td>
						<td>
							<label v-if="item.donationDate != undefined">{{ item.donationDate}}</label>
						</td>
						<td>
							<label v-if="item.activityTitle != undefined">{{ item.activityTitle||'' }}</label>
						</td>
					</tr>
					
				  </table>	
				  <div class="tabbox" v-if='!(searchv&&(list.length > 0))'>
					  <div>
						  <el-image fit='cover' class="img" :src='require("./../../assets/bgimg1.png")'></el-image>
						  <div class="line" v-if='!searchv'>请输入捐助人姓名进行查询</div>
						  <div class="line" v-else>没有相关内容，请重新查询</div>
					  </div>
				  </div>		
				</div>
				
			</div>
								
		</div>
				
		<zhini-pagination :key="componentKey"
			class="zhini-pagination"
			:currentPage="pageNo"
			:totalPage="totalPage"
			@pageNum="pageNum"
		></zhini-pagination>		
	</div>
	
</template>

<script>
import zhiniPagination from "../../components/zhini-pagination.vue";
import moment from 'moment'
import { formatMoney } from '@/utils/util'
export default {
  components: {
     zhiniPagination
  },
  data: function() {
	return {
		name:"",
		searchv:"",
		donateStartDate:"",
		donateStopDate:"",
		
		startTime: "",
		endTime: "",
		list: [],
		curr: 4,
		componentKey: 0,
		pageNo: 1,
		pageSize: 10,
		totalPage: 0,
	};
  },
  created() {
	this.startTime = moment(new Date()).subtract(1, 'years').format('YYYY-MM-DD');
	this.name=this.$route.query.searchv;
	this.donateStartDate=this.$route.query.donateStartDate;
	this.donateStopDate=this.$route.query.donateStopDate;
	this.searchbtn();
  },
  mounted() {
    this.curr = 2;
  },
  methods: {
	goDetail(item){
		this.$router.push({ path: "/lovelist_detail?id="+item.id});
	},
	changeStart(e){
		this.donateStartDate = moment(e).subtract(0, 'years').format('YYYY-MM-DD');
		
		if(moment(this.donateStopDate).diff(moment(this.donateStartDate),'days')<0){ 
			alert("开始时间不能大于结束时间");
			this.donateStartDate=''
		}
	}, 
	changeEnd(e){
		this.donateStopDate = moment(e).subtract(0, 'years').format('YYYY-MM-DD');
		
		if(moment(this.donateStopDate).diff(moment(this.donateStartDate),'days')<0){ 
			alert("开始时间不能大于结束时间");
			this.donateStopDate=''
		}
	},
	searchbtn(){
		this.pageNo=1
		this.searchv=this.name;
		this.Cumulative()
	},
	pageNum(e) {
		window.pageYOffset = 0;
		document.documentElement.scrollTop = 0;
		document.body.scrollTop = 0;		  
		this.pageNo = e;
		this.Cumulative();
	},
	Cumulative() {
		var that = this;
		var dataVal={
			pageNo: this.pageNo,
			pageSize:this.pageSize,
			startTime:this.donateStartDate,
			endTime:this.donateStopDate,
		}
		if(this.searchv){ 
			dataVal.donationUserId=this.searchv
		}else{ 
			delete dataVal.donationUserId
		}
		
		this.httpGet("web/donation/thpDonationRecord/donationList", dataVal).then(res => {
			if(that.searchv){ 
				that.list = res.result.records;
				that.totalPage=Math.ceil(res.result.total / that.pageSize);
			}else{ 
				that.list =[];
				that.totalPage=1
			}
		});
		
		window.pageYOffset = 0;
		document.documentElement.scrollTop = 0;
		document.body.scrollTop = 0;
	},
	// 最近一年
	yearFun() {
		this.curr = 2;
		this.startTime = moment(new Date()).subtract(1, 'years').format('YYYY-MM-DD');
		this.Cumulative();
	},
	// 最近一周
	weekFun() {
		this.curr = 0;
		this.startTime = moment(new Date()).subtract(1, 'weeks').format('YYYY-MM-DD');
		this.Cumulative();
	},
	// 最近一月
	monthFun() {
		this.curr = 1;
		console.log("this.curr:"+this.curr);
		this.startTime = moment(new Date()).subtract(1, 'months').format('YYYY-MM-DD');
		this.Cumulative();
	},
	getFormatMoney(money){
		return formatMoney(money,0)
	},
  },
  
  
  
};
</script>

<style scoped="scoped" lang="scss">
th,
td,
tr,
table {
  margin: auto;
  padding: 0;
  
}
	
.lovelist{
	
	.con_tent{
		display: flex;
		justify-content: center;
	}
	.concar {
		background: #ffffff;
		margin-top: 100px;
		
		.right_c{
			display: flex;
			align-items: center;
			padding: 55px 0px 10px;
			color: #333333;
			.label{
				font-size: 14px;
				font-weight: 400;
			}
			.datacon{
				.el-input__inner{ 
					width: 220px;
					height:40px!important;
					line-height:40px!important;
				}
			}
			.line_c{
				width:20px;
				height: 2px;
				background: #E5E5E5;
				margin-left:20px;
				margin-right:20px;
			}
			.screenbox{ 
				display: flex;
				justify-content: center;
				align-content: center;
				align-items: center;
				.searchcon{
					height: 40px;
					line-height: 40px;
					width: 319px;
					margin-right: 20px;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.inputa{
						font-size:14px;
					}
					
				}
			}
			.btn_search{ 
				width: 76px;
				height: 43px;
				background: #E41E15;
				border-radius: 4px;
				color: #ffffff;
				font-size: 16px;
				margin-left: 21px;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor:pointer;
			}
		}	
		.right_c,.ranktable{
			width: 1009px;
			margin: auto;
		}
		.ranktable{
			margin-top: 20px;
			min-height: 500px;
			margin-bottom: 60px;
			position: relative;
			
			.tabbox{ 
				display: flex;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 100%;
				position: absolute;
				.img{
					width: 284px;
					height: 216px;
				}
				.line{
					position: relative;
					top: -20px;
					text-align: center;
					font-size: 16px;
					font-weight: normal;
					color: #666666;
				}
			}
			table {
			  width: 100%;
			  line-height:50px;
			  border-collapse: collapse;
			  font-size: 14px;
			  font-family: Source Han Sans CN;
			  font-weight: 400;
			  color: #1b1b1b;
			  th,td{
				  box-shadow: 0px 0px 1px #cccccc;
			  }
			  th {
				 background: #F9F9F9;
			  }
			  tr {
				color: #666666;
			    background: #ffffff;
				cursor: pointer;
				
			    td,label {
			      	text-align: center;
					cursor: pointer;
			    }
			    .act {
			      color: #e61f26;
			    }
			
			    td:last-child {
			      border: none;
			    }
			  }
			  tr:last-child {
			    border: none;
			  }
			}				
		}
		
		
	}
		
	
}

</style>
